// Mock data for Centro de Lutas Jardim da Penha Landing Page

export const businessInfo = {
  name: "Centro de Lutas Jardim da Penha",
  phone: "(27) 99298-4896",
  whatsapp: "5527992984896",
  instagram: "@centrodelutasjdpenha",
  address: "Rua Eugenílio Ramos, 665, Shopping Marlim Azul",
  neighborhood: "Jardim da Penha",
  city: "Vitória/ES",
  hours: "6h às 22h",
  fullAddress: "Rua Eugenílio Ramos, 665, Shopping Marlim Azul, Jardim da Penha, Vitória/ES"
};

export const modalities = [
  {
    id: 1,
    name: "Muay Thai",
    description: "A arte das oito armas com Prof. Sarah Coutinho. Desenvolva técnica, condicionamento e mentalidade de lutador.",
    benefits: ["Condicionamento extremo", "Técnica de combate real", "Disciplina mental"],
    image: "muay_thai_action_v2_1774630267798.png",
    level: "Turmas mistas - Todos os níveis",
    instructor: "Prof. Sarah Coutinho",
    schedule: "Segunda a Sexta às 18:00h",
    price: "A partir de R$ 140/mês"
  },
  {
    id: 2,
    name: "Kickboxing / Muay Thai",
    description: "Com Profa. Sarah Coutinho. Aulas intensas pela manhã e noite. Técnica, condicionamento e energia.",
    benefits: ["Treino completo", "Horários flexíveis", "Cardio intenso"],
    image: "muay_thai_action_v2_1774630267798.png",
    level: "Turmas mistas",
    instructor: "Prof. Sarah Coutinho",
    schedule: "Seg, Qua, Sex (06h, 07h, 19h/20h)",
    price: "A partir de R$ 140/mês"
  },
  {
    id: 3,
    name: "Boxe",
    description: "A nobre arte. Aulas exclusivas para homens com treino intenso and técnica apurada.",
    benefits: ["Reflexos aprimorados", "Cardio intenso", "Técnica de esquiva"],
    image: "boxing_action_premium_1774630315645.png",
    level: "Exclusivo para homens",
    schedule: "Ter, Qui, Sex (19h e 20:30h)",
    price: "A partir de R$ 210/mês"
  },
  {
    id: 4,
    name: "Kickfit",
    description: "Treino funcional com técnicas de luta. Queime calorias e ganhe condicionamento.",
    benefits: ["Treino full body", "Alta queima calórica", "Flexibilidade de horários"],
    image: "kickfit_action_premium_v2_1774632260134.png",
    level: "Turmas mistas",
    schedule: "Seg, Qua, Sex (06h-19h) | Ter, Qui (06h-08h)",
    price: "A partir de R$ 160/mês"
  },
  {
    id: 5,
    name: "Jiujitsu",
    description: "Arte suave que vence pela técnica. Aprenda controle, estratégia e submissões.",
    benefits: ["Técnica refinada", "Estratégia mental", "Defesa efetiva"],
    image: "jiujitsu_action_premium_1774630242434.png",
    level: "Todos os níveis",
    schedule: "Seg-Qui às 17:00h e 20:00h",
    price: "A partir de R$ 170/mês"
  },
  {
    id: 6,
    name: "Muay Thai Kids",
    description: "Aula divertida e educativa para crianças. Desenvolva disciplina e confiança desde cedo.",
    benefits: ["Disciplina infantil", "Coordenação motora", "Autoconfiança"],
    image: "martial_arts_kids_premium_1774630331375.png",
    level: "Infantil",
    schedule: "Terça e Quinta às 10:00h e 19:00h",
    price: "A partir de R$ 240/mês"
  },
  {
    id: 7,
    name: "Kick Kids",
    description: "Kickboxing para crianças. Energia, diversão e aprendizado em um só lugar.",
    benefits: ["Coordenação motora", "Disciplina", "Socialização"],
    image: "martial_arts_kids_premium_1774630331375.png",
    level: "Infantil",
    schedule: "Seg, Qua, Qui (09:10h e 18:10h)",
    price: "A partir de R$ 240/mês"
  },
  {
    id: 8,
    name: "Judo Kids",
    description: "Judo tradicional para crianças. Desenvolva respeito, equilíbrio e técnica.",
    benefits: ["Respeito e disciplina", "Equilíbrio", "Autocontrole"],
    image: "martial_arts_kids_premium_1774630331375.png",
    level: "Infantil",
    schedule: "Seg-Qui (09h, 10h, 17h, 18:15h)",
    price: "A partir de R$ 260/mês"
  },
  {
    id: 9,
    name: "Ginástica Rítmica",
    description: "Lorena Sartori Excellence. Arte, graciosidade e disciplina para crianças.",
    benefits: ["Flexibilidade", "Coordenação", "Expressão artística"],
    image: "martial_arts_kids_premium_1774630331375.png",
    level: "Infantil",
    schedule: "Terça e Quinta às 09:00h",
    price: "R$ 290/mês"
  }
];

export const benefits = [
  {
    id: 1,
    icon: "Flame",
    title: "Condicionamento Físico Extremo",
    description: "Queime calorias, ganhe força e resistência através do treino mais completo que existe."
  },
  {
    id: 2,
    icon: "Shield",
    title: "Autoconfiança e Segurança",
    description: "Desenvolva segurança pessoal e aprenda a se defender em situações reais."
  },
  {
    id: 3,
    icon: "Brain",
    title: "Disciplina Mental",
    description: "Fortaleça sua mente, controle emocional e foco através das artes marciais."
  },
  {
    id: 4,
    icon: "Heart",
    title: "Alívio do Estresse",
    description: "Libere tensões do dia a dia através do treino intenso e focado."
  },
  {
    id: 5,
    icon: "Users",
    title: "Comunidade Real",
    description: "Faça parte de uma família de lutadores que se apoia e evolui junto."
  },
  {
    id: 6,
    icon: "Target",
    title: "Resultados Reais",
    description: "Transformação física e mental comprovada por centenas de alunos."
  }
];

export const instructors = [
  {
    id: 1,
    name: "Professora Sarah Coutinho",
    title: "Instrutora de Kickboxing e Muay Thai",
    experience: "Especialista em Kickboxing e Muay Thai",
    credentials: "Instrutora certificada",
    bio: "Aulas dinâmicas pela manhã e noite. Treino intenso e transformador.",
    image: "professora_sarah_final.png",
    instagram: "@profsarahcoutinho",
    schedule: "Seg, Qua, Sex (06h, 07h, 19h/20h) + Seg-Sex (18h)"
  },
  {
    id: 2,
    name: "Equipe de Instrutores",
    title: "Boxe, Judo, Jiujitsu e outras modalidades",
    experience: "Anos de experiência",
    credentials: "Profissionais qualificados",
    bio: "Equipe dedicada de professores experientes em artes marciais e combate.",
    image: "https://images.pexels.com/photos/6699100/pexels-photo-6699100.jpeg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rafael Costa",
    age: 32,
    profession: "Empresário",
    text: "Comecei do zero há 8 meses. Perdi 15kg, ganhei confiança e encontrei uma família. Melhor decisão que tomei.",
    rating: 5,
    time: "8 meses de treino",
    avatar: "RC"
  },
  {
    id: 2,
    name: "Juliana Mendes",
    age: 28,
    profession: "Arquiteta",
    text: "Sempre tive medo de começar, mas o ambiente é super acolhedor. Hoje me sinto forte, confiante e muito mais segura.",
    rating: 5,
    time: "1 ano de treino",
    avatar: "JM"
  },
  {
    id: 3,
    name: "Thiago Oliveira",
    age: 25,
    profession: "Desenvolvedor",
    text: "O treino aqui não tem nada de amador. É técnica real, professor qualificado e evolução constante. Nível premium de verdade.",
    rating: 5,
    time: "6 meses de treino",
    avatar: "TO"
  },
  {
    id: 4,
    name: "Mariana Santos",
    age: 35,
    profession: "Advogada",
    text: "Procurava um lugar sério para treinar. Achei muito mais: estrutura impecável, professores incríveis e resultados reais.",
    rating: 5,
    time: "1 ano e meio de treino",
    avatar: "MS"
  },
  {
    id: 5,
    name: "Carlos Eduardo",
    age: 42,
    profession: "Médico",
    text: "Voltei a treinar depois de anos parado. A energia do lugar é contagiante. Recuperei forma física e motivação.",
    rating: 5,
    time: "4 meses de treino",
    avatar: "CE"
  },
  {
    id: 6,
    name: "Amanda Silva",
    age: 24,
    profession: "Estudante",
    text: "Ambiente perfeito para mulheres que querem começar. Me sinto respeitada, forte e parte de uma comunidade incrível.",
    rating: 5,
    time: "10 meses de treino",
    avatar: "AS"
  }
];

export const schedule = {
  monday: [
    { time: "06:00", class: "Kickboxing/Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "07:00", class: "Kickboxing/Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "06:00", class: "Kickfit", level: "Turma Mista", instructor: "Equipe" },
    { time: "09:10", class: "Kick Kids", level: "Infantil", instructor: "Equipe" },
    { time: "10:00", class: "Judo Kids", level: "Infantil", instructor: "Equipe" },
    { time: "17:00", class: "Jiujitsu", level: "Todos os níveis", instructor: "Equipe" },
    { time: "17:00", class: "Judo Kids", level: "Infantil", instructor: "Equipe" },
    { time: "18:00", class: "Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "18:10", class: "Kick Kids", level: "Infantil", instructor: "Equipe" },
    { time: "19:00", class: "Kickfit", level: "Turma Mista", instructor: "Equipe" },
    { time: "20:00", class: "Jiujitsu", level: "Todos os níveis", instructor: "Equipe" },
    { time: "20:00", class: "Kickboxing/Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" }
  ],
  tuesday: [
    { time: "06:00", class: "Kickfit", level: "Turma Mista", instructor: "Equipe" },
    { time: "08:00", class: "Kickfit", level: "Turma Mista", instructor: "Equipe" },
    { time: "09:00", class: "Judo Kids", level: "Infantil", instructor: "Equipe" },
    { time: "09:00", class: "Ginástica Rítmica", level: "Infantil", instructor: "Lorena Sartori" },
    { time: "10:00", class: "Muay Thai Kids", level: "Infantil", instructor: "Equipe" },
    { time: "17:00", class: "Jiujitsu", level: "Todos os níveis", instructor: "Equipe" },
    { time: "17:00", class: "Judo Kids", level: "Infantil", instructor: "Equipe" },
    { time: "18:00", class: "Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "18:15", class: "Judo Kids", level: "Infantil", instructor: "Equipe" },
    { time: "19:00", class: "Boxe", level: "Exclusivo Homens", instructor: "Equipe" },
    { time: "19:00", class: "Muay Thai Kids", level: "Infantil", instructor: "Equipe" },
    { time: "20:00", class: "Jiujitsu", level: "Todos os níveis", instructor: "Equipe" }
  ],
  wednesday: [
    { time: "06:00", class: "Kickboxing/Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "06:00", class: "Kickfit", level: "Turma Mista", instructor: "Equipe" },
    { time: "07:00", class: "Kickboxing/Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "09:10", class: "Kick Kids", level: "Infantil", instructor: "Equipe" },
    { time: "10:00", class: "Judo Kids", level: "Infantil", instructor: "Equipe" },
    { time: "17:00", class: "Jiujitsu", level: "Todos os níveis", instructor: "Equipe" },
    { time: "17:00", class: "Judo Kids", level: "Infantil", instructor: "Equipe" },
    { time: "18:00", class: "Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "18:10", class: "Kick Kids", level: "Infantil", instructor: "Equipe" },
    { time: "19:00", class: "Kickfit", level: "Turma Mista", instructor: "Equipe" },
    { time: "20:00", class: "Jiujitsu", level: "Todos os níveis", instructor: "Equipe" },
    { time: "20:00", class: "Kickboxing/Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" }
  ],
  thursday: [
    { time: "06:00", class: "Kickfit", level: "Turma Mista", instructor: "Equipe" },
    { time: "08:00", class: "Kickfit", level: "Turma Mista", instructor: "Equipe" },
    { time: "09:00", class: "Judo Kids", level: "Infantil", instructor: "Equipe" },
    { time: "09:00", class: "Ginástica Rítmica", level: "Infantil", instructor: "Lorena Sartori" },
    { time: "09:10", class: "Kick Kids", level: "Infantil", instructor: "Equipe" },
    { time: "10:00", class: "Muay Thai Kids", level: "Infantil", instructor: "Equipe" },
    { time: "17:00", class: "Jiujitsu", level: "Todos os níveis", instructor: "Equipe" },
    { time: "17:00", class: "Judo Kids", level: "Infantil", instructor: "Equipe" },
    { time: "18:00", class: "Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "18:10", class: "Kick Kids", level: "Infantil", instructor: "Equipe" },
    { time: "18:15", class: "Judo Kids", level: "Infantil", instructor: "Equipe" },
    { time: "19:00", class: "Boxe", level: "Exclusivo Homens", instructor: "Equipe" },
    { time: "19:00", class: "Muay Thai Kids", level: "Infantil", instructor: "Equipe" },
    { time: "20:00", class: "Jiujitsu", level: "Todos os níveis", instructor: "Equipe" }
  ],
  friday: [
    { time: "06:00", class: "Kickboxing/Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "06:00", class: "Kickfit", level: "Turma Mista", instructor: "Equipe" },
    { time: "07:00", class: "Kickboxing/Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "18:00", class: "Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "19:00", class: "Kickboxing/Muay Thai", level: "Turma Mista", instructor: "Prof. Sarah Coutinho" },
    { time: "19:00", class: "Boxe", level: "Exclusivo Homens", instructor: "Equipe" },
    { time: "19:00", class: "Kickfit", level: "Turma Mista", instructor: "Equipe" },
    { time: "20:30", class: "Boxe", level: "Exclusivo Homens", instructor: "Equipe" }
  ],
  saturday: [
    { time: "09:00", class: "Treino Livre", level: "Todos os Níveis", instructor: "Todos os professores" }
  ]
};

export const pricing = [
  {
    id: 1,
    name: "Muay Thai",
    price: "R$ 140",
    period: "/mês",
    originalPrice: "R$ 170",
    description: "Plano Anual - 2x/semana",
    features: [
      "Segunda a Sexta 18:00h",
      "Prof. Sarah Coutinho",
      "Turmas mistas",
      "Matrícula: R$ 69,90",
      "Economia de R$ 360/ano"
    ],
    highlighted: false,
    cta: "Começar Agora"
  },
  {
    id: 2,
    name: "Kickfit",
    price: "R$ 160",
    period: "/mês",
    originalPrice: "R$ 200",
    description: "Plano Anual - 2x/semana",
    features: [
      "Horários flexíveis",
      "Treino funcional",
      "Turmas mistas",
      "Matrícula: R$ 90,00",
      "Alta queima calórica"
    ],
    highlighted: false,
    cta: "Quero Treinar"
  },
  {
    id: 3,
    name: "Boxe",
    price: "R$ 210",
    period: "/mês",
    originalPrice: "R$ 240",
    description: "Plano Anual - 2x/semana",
    features: [
      "Terça, Quinta e Sexta",
      "Exclusivo para homens",
      "Técnica apurada",
      "Matrícula: R$ 80,00",
      "Instrutores experientes"
    ],
    highlighted: false,
    cta: "Começar Agora"
  },
  {
    id: 4,
    name: "Jiujitsu",
    price: "R$ 170",
    period: "/mês",
    originalPrice: "R$ 200",
    description: "Plano Anual",
    features: [
      "Segunda a Quinta",
      "17:00h e 20:00h",
      "Todos os níveis",
      "Matrícula: R$ 80,00",
      "Arte suave e efetiva"
    ],
    highlighted: false,
    cta: "Quero Treinar"
  },
  {
    id: 5,
    name: "Modalidades Kids",
    price: "R$ 240",
    period: "/mês",
    description: "Plano Anual - Infantil",
    features: [
      "Muay Thai Kids, Kick Kids ou Judo",
      "Horários manhã e tarde",
      "Aulas educativas e divertidas",
      "Uniforme personalizado",
      "Desenvolve disciplina"
    ],
    highlighted: false,
    cta: "Matricular Criança"
  }
];

export const faqData = [
  {
    id: 1,
    question: "Nunca treinei artes marciais. Posso começar?",
    answer: "Absolutamente! A maioria dos nossos alunos começou do zero. Temos turmas específicas para iniciantes e nossos professores são experientes em ensinar desde o básico. Você vai evoluir no seu ritmo, com segurança e acompanhamento individual."
  },
  {
    id: 2,
    question: "Qual é a frequência ideal de treino?",
    answer: "Recomendamos começar com 2-3 vezes por semana e, conforme você se adapta, aumentar para 4-5 vezes. Nosso plano permite aulas ilimitadas, então você pode treinar quantas vezes quiser e se sentir confortável."
  },
  {
    id: 3,
    question: "Preciso estar em forma para começar?",
    answer: "Não! O treino é que vai te colocar em forma. Nossos professores adaptam os exercícios ao nível de cada aluno. Você começa do seu jeito e evolui gradualmente. Muitos alunos que chegaram aqui sem condicionamento hoje estão irreconhecíveis."
  },
  {
    id: 4,
    question: "Mulheres são bem-vindas?",
    answer: "Muito bem-vindas! Temos várias alunas e uma professora incrível. O ambiente é totalmente respeitoso e acolhedor. Muitas mulheres descobriram aqui uma forma de ganhar confiança, segurança e empoderamento."
  },
  {
    id: 5,
    question: "O que preciso levar para a primeira aula?",
    answer: "Para a aula experimental, basta levar roupa confortável (shorts e camiseta), toalha e água. Nós fornecemos luvas e equipamentos para você experimentar. Se decidir continuar, orientamos sobre os equipamentos pessoais."
  },
  {
    id: 6,
    question: "Como funciona a aula experimental?",
    answer: "A aula experimental é gratuita e sem compromisso. Você participa de uma aula normal, conhece os professores, sente a energia do lugar e entende se é pra você. É só entrar em contato pelo WhatsApp e agendar o melhor horário."
  },
  {
    id: 7,
    question: "Qual a idade mínima para treinar?",
    answer: "Aceitamos alunos a partir de 14 anos nas turmas regulares. Para crianças menores, estamos estruturando turmas kids. Entre em contato para mais informações sobre o projeto infantil."
  },
  {
    id: 8,
    question: "Posso treinar mais de uma modalidade?",
    answer: "Sim! Nosso plano dá acesso ilimitado a todas as modalidades: Muay Thai, Boxe, Kickboxing e Defesa Pessoal. Muitos alunos combinam diferentes artes marciais e isso acelera a evolução."
  },
  {
    id: 9,
    question: "O treino é seguro?",
    answer: "Totalmente seguro. Trabalhamos com progressão gradual, professores qualificados, equipamentos de proteção adequados e supervisão constante. Segurança é nossa prioridade. Você vai aprender a se defender, não se machucar."
  },
  {
    id: 10,
    question: "Vocês têm chuveiro e vestiário?",
    answer: "Sim! Temos vestiários masculino e feminino com chuveiros, armários e toda estrutura para você treinar confortavelmente antes ou depois do trabalho."
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1696454411305-311d11bb8c30",
    category: "training",
    alt: "Treino de Muay Thai no ringue"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1517438322307-e67111335449",
    category: "training",
    alt: "Treino de boxe"
  },
  {
    id: 3,
    url: "https://images.pexels.com/photos/5424531/pexels-photo-5424531.jpeg",
    category: "training",
    alt: "Kickboxing em ação"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1716307035615-1c6465a32ef2",
    category: "facility",
    alt: "Academia equipada"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1716307046875-4c4ba2f43cab",
    category: "facility",
    alt: "Ringue profissional"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1716307043003-dbe6a5cc496e",
    category: "equipment",
    alt: "Equipamentos profissionais"
  },
  {
    id: 7,
    url: "https://images.unsplash.com/photo-1611824916163-a984d622d042",
    category: "equipment",
    alt: "Luvas de Muay Thai"
  },
  {
    id: 8,
    url: "https://images.pexels.com/photos/6699100/pexels-photo-6699100.jpeg",
    category: "training",
    alt: "Treino com foco técnico"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Professores Qualificados",
    description: "Instrutores com formação internacional, experiência em competição e anos ensinando.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Estrutura Premium",
    description: "Academia equipada com ringue profissional, sacos de qualidade e equipamentos modernos.",
    icon: "Building"
  },
  {
    id: 3,
    title: "Treino Real, Não Improviso",
    description: "Técnica autêntica, metodologia comprovada e progressão estruturada para todos os níveis.",
    icon: "Target"
  },
  {
    id: 4,
    title: "Ambiente Acolhedor",
    description: "Comunidade forte, respeitosa e motivadora. Aqui você é parte de uma família.",
    icon: "Heart"
  },
  {
    id: 5,
    title: "Localização Privilegiada",
    description: "No coração de Jardim da Penha, fácil acesso e amplo estacionamento.",
    icon: "MapPin"
  },
  {
    id: 6,
    title: "Horários Flexíveis",
    description: "Das 6h às 22h, de segunda a sábado. Você treina no horário que funciona pra você.",
    icon: "Clock"
  }
];
